import { client } from "../useShopifyClient";
import { isEnableShopify,shopifyConst } from "@/hooks/shopify-hooks/useShopifyConst";

const request = (query, variables) => {
  try {
    return new Promise((resolve, reject) => {
      const {storefrontAccessToken,domain } = shopifyConst;
      if (!isEnableShopify) {
        return reject("No opend Shopify API calls allowed. Please check your configuration.");
      }
      if (isEnableShopify && (!storefrontAccessToken || !domain)) {
        return reject("The necessary parameters, storefrontAccessToken and domain are empty.");
      };

      client.request(query, {
        variables,
      })
        .then((result) => {
          resolve(result);
        })
        .catch((err) => {
          reject(err);
        });
    });
  } catch (e) {
    console.error(e);
  }
};

/**
 * authored: zhousj6
 * requirement：优化请求，使用回调函数处理数据，例如一个页面有多处要查询产品信息，为了避免重复发起请求，统一发起一次请求，然后通过回调函数返回数据，
 * 
 */
window.csr = window.csr || {};
/**
 *
 * @param {*} query
 * @param {*} variables
 * @param {*} type :product | customer | cartquery
 * @param {*} cb：请求完成后的回调
 * @returns 请求返回的结果
 */
const singleRequest = (query, variables, type = "product", cb) => {
  window.csr[type] = window.csr[type] || {};
  window.csr[type].cbs = window.csr[type].cbs || {};

  try {
    return new Promise((resolve, reject) => {
      const uniqueKey = `product-${variables.query}`;
      // window对象上有这个属性，则说明已经发起过请求了
      // eslint-disable-next-line
      if (window.csr[type].hasOwnProperty(uniqueKey)) {
        if (!window.csr[type][uniqueKey].isLoading) {// 请求已经发起且返回
          // 获取存在window上的返回数据并执行回调
          const res = window.csr[type][uniqueKey];
          cb(res);
          resolve(res);
        } else {// 正在发起请求，后续的回调都存起来
          window.csr[type].cbs[uniqueKey].push(cb);
        }
      } else {
        /**
         * 未发起过请求，初始化这个uniqueKey的对象，包含：
         * isLoading：true，已经发起请求，但是还没有返回；false，已经发起过请求，且已经返回了
         * cbs：所有发起这个请求的成功回调
         */
        window.csr[type][uniqueKey] = {
          isLoading: true,
        };

        window.csr[type].cbs[uniqueKey] = [];
        // 把第一个发起请求的回调push进去
        window.csr[type].cbs[uniqueKey].push(cb);
        window.csr[type][uniqueKey].isLoading = true;
        // 发起请求
        client.request(query, {
          variables,
        })
          .then((result) => {
            // 请求返回后，将isLoading置为false，获取所有的回调，将结果传递并执行
            window.csr[type][uniqueKey].isLoading = false;
            const cbs = window.csr[type].cbs[uniqueKey];
            cbs.forEach((cbi) => {
              cbi && cbi(result);
            });
            window.csr[type].cbs[uniqueKey] = [];
            // 将结果挂载到window对象上
            window.csr[type][uniqueKey] = result;
            resolve(result);
          })
          .catch((err) => {
            reject(err);
          });
      }
    });
  } catch (e) {
    console.log(e);
  }
};

const baseRequest = (query, variables, type, cb) => {
  return new Promise((resolve, reject) => {
    (async () => {
      try {
        // cb为空，则标明请求不需要唯一化处理
        if (cb) {
          resolve(await singleRequest(query, variables, type = "product", cb));
        } else {
          resolve(await request(query, variables));
        }
      } catch (e) {
        reject(e);
      }
    })();
  });
}

export default baseRequest;
